module.exports = __webpack_public_path__ + "img/rlogo-2-old.39b2c22a.png";